import React, {Component} from 'react';
import {connect} from 'react-redux';
import VariablesForm from '../components/VariablesForm';
import {DATA_SETS} from '../Constants';
import './Forms.css';

const META_DATA = [
  { key: 'slope', displayName: 'Slope (deg)', min: -90, max: 90 }
];

class GrassVariables extends Component {
  render() {
    return <VariablesForm data_set={DATA_SETS.GRASS}
                          meta_data={META_DATA}
                          variables={this.props.variables}
                          dispatch={this.props.dispatch}/>;
  }
}

const mapStateToProps = state => {
  return {
    variables: {
      slope: state.point_data_grass.slope
    }
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GrassVariables);



// WEBPACK FOOTER //
// ./src/containers/GrassVariables.js